import React from 'react';
import { Box } from '@mui/material';

const formatDate = (isoDate) => {
    return new Intl.DateTimeFormat('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'America/Los_Angeles',
    }).format(new Date(isoDate));
};

const BlogPostMeta = ({ publishedDate, updatedDate }) => {
    if (!publishedDate) return null;

    const showUpdated = updatedDate && updatedDate !== publishedDate;

    return (
        <Box className="post-meta">
            <span>By Raman Yakkala</span>
            <span>
                Published <time dateTime={publishedDate}>{formatDate(publishedDate)}</time>
            </span>
            {showUpdated && (
                <span>
                    Updated <time dateTime={updatedDate}>{formatDate(updatedDate)}</time>
                </span>
            )}
        </Box>
    );
};

export default BlogPostMeta;
